import { CreateService, CRUDServiceInterface } from '@/services/service';
import { BulletinReactionEntity } from '@/entities/bulletin-reaction.entity';

export default class BulletinReactionService
  extends CreateService<BulletinReactionEntity>('bulletin-reaction')
  implements CRUDServiceInterface<BulletinReactionEntity>
{
  async getOne(
    id: number,
    join: string[] = ['staff'],
  ): Promise<BulletinReactionEntity> {
    this.apiBuilder.reset()
    return super.getOne(id, join);
  }
  async getMany(
    bulletinId: string | number,
    emoticonId: string | number,
  ): Promise<BulletinReactionEntity[]> {
    await this.apiBuilder.reset();
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('bulletinId', '$eq', String(bulletinId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
